// City/State to coordinates mapping for transaction locations
const locationCoords = {
  // Kansas
  'WICHITA': { lat: 37.6872, lng: -97.3301, name: 'Wichita, KS' },
  'GODDARD': { lat: 37.6597, lng: -97.5753, name: 'Goddard, KS' },
  'MAIZE': { lat: 37.7789, lng: -97.4672, name: 'Maize, KS' },
  'DERBY': { lat: 37.5456, lng: -97.2689, name: 'Derby, KS' },
  'ANDOVER': { lat: 37.7139, lng: -97.1364, name: 'Andover, KS' },
  'KANSAS CITY': { lat: 39.0997, lng: -94.5786, name: 'Kansas City' },
  'OLATHE': { lat: 38.8814, lng: -94.8191, name: 'Olathe, KS' },
  'OVERLAND PARK': { lat: 38.9822, lng: -94.6708, name: 'Overland Park, KS' },
  'TOPEKA': { lat: 39.0558, lng: -95.6890, name: 'Topeka, KS' },
  'HUTCHINSON': { lat: 38.0608, lng: -97.9298, name: 'Hutchinson, KS' },
  'SALINA': { lat: 38.8403, lng: -97.6114, name: 'Salina, KS' },
  'AUGUSTA': { lat: 37.6867, lng: -96.9767, name: 'Augusta, KS' },
  'PAOLA': { lat: 38.5722, lng: -94.8791, name: 'Paola, KS' },

  // Utah
  'SALT LAKE': { lat: 40.7608, lng: -111.8910, name: 'Salt Lake City, UT' },
  'PROVO': { lat: 40.2338, lng: -111.6585, name: 'Provo, UT' },
  'LOGAN': { lat: 41.7370, lng: -111.8338, name: 'Logan, UT' },
  'SAINT GEORGE': { lat: 37.0965, lng: -113.5684, name: 'St. George, UT' },
  'ST GEORGE': { lat: 37.0965, lng: -113.5684, name: 'St. George, UT' },
  'LEHI': { lat: 40.3916, lng: -111.8508, name: 'Lehi, UT' },
  'OREM': { lat: 40.2969, lng: -111.6946, name: 'Orem, UT' },
  'DRAPER': { lat: 40.5247, lng: -111.8638, name: 'Draper, UT' },
  'SANDY': { lat: 40.5649, lng: -111.8590, name: 'Sandy, UT' },
  'MURRAY': { lat: 40.6669, lng: -111.8879, name: 'Murray, UT' },
  'HIGHLAND': { lat: 40.4263, lng: -111.7958, name: 'Highland, UT' },
  'AMERICAN FORK': { lat: 40.3769, lng: -111.7957, name: 'American Fork, UT' },
  'PLEASANT GROVE': { lat: 40.3641, lng: -111.7385, name: 'Pleasant Grove, UT' },
  'SPANISH FORK': { lat: 40.1149, lng: -111.6549, name: 'Spanish Fork, UT' },
  'BRIGHAM': { lat: 41.5102, lng: -112.0155, name: 'Brigham City, UT' },
  'FARMINGTON': { lat: 40.9805, lng: -111.8874, name: 'Farmington, UT' },
  'WASHINGTON': { lat: 37.1305, lng: -113.5083, name: 'Washington, UT' },
  'HURRICANE': { lat: 37.1753, lng: -113.2899, name: 'Hurricane, UT' },
  'ALPINE': { lat: 40.4533, lng: -111.7780, name: 'Alpine, UT' },
  'REXBURG': { lat: 43.8260, lng: -111.7897, name: 'Rexburg, ID' },

  // Texas
  'AUSTIN': { lat: 30.2672, lng: -97.7431, name: 'Austin, TX' },
  'HOUSTON': { lat: 29.7604, lng: -95.3698, name: 'Houston, TX' },
  'DALLAS': { lat: 32.7767, lng: -96.7970, name: 'Dallas, TX' },
  'FORT WORTH': { lat: 32.7555, lng: -97.3308, name: 'Fort Worth, TX' },
  'SAN ANTONIO': { lat: 29.4241, lng: -98.4936, name: 'San Antonio, TX' },
  'CEDAR PARK': { lat: 30.5052, lng: -97.8203, name: 'Cedar Park, TX' },
  'DENTON': { lat: 33.2148, lng: -97.1331, name: 'Denton, TX' },
  'WAXAHACHIE': { lat: 32.3865, lng: -96.8483, name: 'Waxahachie, TX' },
  'BEAUMONT': { lat: 30.0802, lng: -94.1266, name: 'Beaumont, TX' },
  'HAMILTON': { lat: 31.7038, lng: -98.1239, name: 'Hamilton, TX' },
  'DESTIN': { lat: 30.3935, lng: -86.4958, name: 'Destin, FL' },

  // California
  'LOS ANGELES': { lat: 34.0522, lng: -118.2437, name: 'Los Angeles, CA' },
  'SAN FRANCISCO': { lat: 37.7749, lng: -122.4194, name: 'San Francisco, CA' },
  'SAN DIEGO': { lat: 32.7157, lng: -117.1611, name: 'San Diego, CA' },
  'ANAHEIM': { lat: 33.8366, lng: -117.9143, name: 'Anaheim, CA' },
  'NEWPORT BEACH': { lat: 33.6189, lng: -117.9289, name: 'Newport Beach, CA' },
  'LAGUNA BEACH': { lat: 33.5427, lng: -117.7854, name: 'Laguna Beach, CA' },
  'SANTA CLARA': { lat: 37.3541, lng: -121.9552, name: 'Santa Clara, CA' },
  'REDWOOD CITY': { lat: 37.4852, lng: -122.2364, name: 'Redwood City, CA' },
  'CLEARWATER': { lat: 27.9659, lng: -82.8001, name: 'Clearwater, FL' },
  'VICTOR': { lat: 46.3927, lng: -114.1583, name: 'Victor, MT' },
  'BARSTOW': { lat: 34.8958, lng: -117.0173, name: 'Barstow, CA' },

  // Georgia
  'ATLANTA': { lat: 33.7490, lng: -84.3880, name: 'Atlanta, GA' },
  'MARIETTA': { lat: 33.9526, lng: -84.5499, name: 'Marietta, GA' },
  'SMYRNA': { lat: 33.8839, lng: -84.5144, name: 'Smyrna, GA' },
  'KENNESAW': { lat: 34.0234, lng: -84.6155, name: 'Kennesaw, GA' },

  // Oklahoma
  'OKLAHOMA CITY': { lat: 35.4676, lng: -97.5164, name: 'Oklahoma City, OK' },
  'EDMOND': { lat: 35.6528, lng: -97.4781, name: 'Edmond, OK' },
  'ARDMORE': { lat: 34.1743, lng: -97.1436, name: 'Ardmore, OK' },

  // Nevada
  'LAS VEGAS': { lat: 36.1699, lng: -115.1398, name: 'Las Vegas, NV' },
  'HENDERSON': { lat: 36.0395, lng: -114.9817, name: 'Henderson, NV' },

  // Arizona
  'PHOENIX': { lat: 33.4484, lng: -112.0740, name: 'Phoenix, AZ' },
  'TEMPE': { lat: 33.4255, lng: -111.9400, name: 'Tempe, AZ' },
  'PAGE': { lat: 36.9147, lng: -111.4558, name: 'Page, AZ' },

  // Colorado
  'DENVER': { lat: 39.7392, lng: -104.9903, name: 'Denver, CO' },

  // Washington
  'SEATTLE': { lat: 47.6062, lng: -122.3321, name: 'Seattle, WA' },
  'YAKIMA': { lat: 46.6021, lng: -120.5059, name: 'Yakima, WA' },

  // Idaho
  'IDAHO FALLS': { lat: 43.4917, lng: -112.0339, name: 'Idaho Falls, ID' },
  'WENDELL': { lat: 42.7741, lng: -114.7052, name: 'Wendell, ID' },

  // Illinois
  'CHICAGO': { lat: 41.8781, lng: -87.6298, name: 'Chicago, IL' },
  'NORTHBROOK': { lat: 42.1275, lng: -87.8289, name: 'Northbrook, IL' },

  // Nebraska
  'OMAHA': { lat: 41.2565, lng: -95.9345, name: 'Omaha, NE' },
  'LINCOLN': { lat: 40.8258, lng: -96.6852, name: 'Lincoln, NE' },

  // Missouri
  'PLATTE CITY': { lat: 39.3694, lng: -94.7824, name: 'Platte City, MO' },

  // Hawaii
  'KANEOHE': { lat: 21.4180, lng: -157.8036, name: 'Kaneohe, HI' },
  'LAHAINA': { lat: 20.8783, lng: -156.6825, name: 'Lahaina, HI' },

  // New York
  'NEW YORK': { lat: 40.7128, lng: -74.0060, name: 'New York, NY' },

  // International - Europe
  'PARIS': { lat: 48.8566, lng: 2.3522, name: 'Paris, France' },
  'STUTTGART': { lat: 48.7758, lng: 9.1829, name: 'Stuttgart, Germany' },
  'RUGELEY': { lat: 52.7580, lng: -1.9350, name: 'Rugeley, UK' },
  'LONDON': { lat: 51.5074, lng: -0.1278, name: 'London, UK' },

  // International - Asia
  'TAIPEI': { lat: 25.0330, lng: 121.5654, name: 'Taipei, Taiwan' },
  'TAOYUAN': { lat: 24.9936, lng: 121.3010, name: 'Taoyuan, Taiwan' },
  'KAOHSIUNG': { lat: 22.6273, lng: 120.3014, name: 'Kaohsiung, Taiwan' },
  'TAINAN': { lat: 22.9998, lng: 120.2269, name: 'Tainan, Taiwan' },
  'TAICHUNG': { lat: 24.1477, lng: 120.6736, name: 'Taichung, Taiwan' },
  'HUALIEN': { lat: 23.9871, lng: 121.6016, name: 'Hualien, Taiwan' },
  'YOUBIKE': { lat: 25.0330, lng: 121.5654, name: 'Taipei, Taiwan' },
  'TAIWAN': { lat: 25.0330, lng: 121.5654, name: 'Taiwan' },
  'HONG KONG': { lat: 22.3193, lng: 114.1694, name: 'Hong Kong' },
  'HONGKONG': { lat: 22.3193, lng: 114.1694, name: 'Hong Kong' },
  'HK': { lat: 22.3193, lng: 114.1694, name: 'Hong Kong' },
  'KOWLOON': { lat: 22.3219, lng: 114.1693, name: 'Kowloon, Hong Kong' },
  'DISNEYLAND': { lat: 22.3130, lng: 114.0413, name: 'Hong Kong Disneyland' },
  'LANTAU': { lat: 22.2667, lng: 113.9500, name: 'Lantau Island, HK' },
  'TOKYO': { lat: 35.6762, lng: 139.6503, name: 'Tokyo, Japan' },
  'OSAKA': { lat: 34.6937, lng: 135.5023, name: 'Osaka, Japan' },
  'KYOTO': { lat: 35.0116, lng: 135.7681, name: 'Kyoto, Japan' },
  'SEOUL': { lat: 37.5665, lng: 126.9780, name: 'Seoul, South Korea' },
  'SINGAPORE': { lat: 1.3521, lng: 103.8198, name: 'Singapore' },
  'BANGKOK': { lat: 13.7563, lng: 100.5018, name: 'Bangkok, Thailand' },
  'MANILA': { lat: 14.5995, lng: 120.9842, name: 'Manila, Philippines' },
  'BEIJING': { lat: 39.9042, lng: 116.4074, name: 'Beijing, China' },
  'SHANGHAI': { lat: 31.2304, lng: 121.4737, name: 'Shanghai, China' },
  'SHENZHEN': { lat: 22.5431, lng: 114.0579, name: 'Shenzhen, China' },

  // International - Oceania
  'AUCKLAND': { lat: -36.8485, lng: 174.7633, name: 'Auckland, NZ' },
  'QUEENSTOWN': { lat: -45.0312, lng: 168.6626, name: 'Queenstown, NZ' },
  'SYDNEY': { lat: -33.8688, lng: 151.2093, name: 'Sydney, Australia' },
  'MELBOURNE': { lat: -37.8136, lng: 144.9631, name: 'Melbourne, Australia' },
};

// Extract location from transaction description
export function extractLocation(description) {
  if (!description) return null;

  const upperDesc = description.toUpperCase();

  // Check each known location
  for (const [key, coords] of Object.entries(locationCoords)) {
    if (upperDesc.includes(key)) {
      return coords;
    }
  }

  // Try to extract state codes
  const stateMatch = upperDesc.match(/\b([A-Z]{2})\s*(USA|$)/);
  if (stateMatch) {
    const stateCode = stateMatch[1];
    const stateCoords = {
      'KS': { lat: 38.5, lng: -98.0, name: 'Kansas' },
      'UT': { lat: 39.3, lng: -111.5, name: 'Utah' },
      'TX': { lat: 31.0, lng: -100.0, name: 'Texas' },
      'CA': { lat: 36.7, lng: -119.4, name: 'California' },
      'GA': { lat: 32.1, lng: -82.9, name: 'Georgia' },
      'OK': { lat: 35.0, lng: -97.0, name: 'Oklahoma' },
      'NV': { lat: 38.8, lng: -116.4, name: 'Nevada' },
      'AZ': { lat: 34.0, lng: -111.0, name: 'Arizona' },
      'CO': { lat: 39.5, lng: -105.8, name: 'Colorado' },
      'WA': { lat: 47.7, lng: -120.7, name: 'Washington' },
      'ID': { lat: 44.1, lng: -114.7, name: 'Idaho' },
      'IL': { lat: 40.6, lng: -89.3, name: 'Illinois' },
      'NE': { lat: 41.5, lng: -99.9, name: 'Nebraska' },
      'MO': { lat: 38.5, lng: -92.3, name: 'Missouri' },
      'HI': { lat: 19.9, lng: -155.6, name: 'Hawaii' },
      'NY': { lat: 40.7, lng: -74.0, name: 'New York' },
      'FL': { lat: 27.6, lng: -81.5, name: 'Florida' },
      'AL': { lat: 32.3, lng: -86.9, name: 'Alabama' },
      'SC': { lat: 33.8, lng: -81.2, name: 'South Carolina' },
      'MA': { lat: 42.4, lng: -71.4, name: 'Massachusetts' },
    };
    if (stateCoords[stateCode]) {
      return stateCoords[stateCode];
    }
  }

  return null;
}

export default locationCoords;
